import styled from 'styled-components'

export const SelectWrapper = styled.div<{ noMargin?: boolean; minWidth?: number; minHeight?: number }>`
  position: relative;
  border-radius: 2px;
  user-select: none;
  font-weight: 400;
  min-width: ${({ minWidth }) => (minWidth ? `${minWidth}px` : '95px')};
  min-height: ${({ minHeight }) => (minHeight ? `${minHeight}px ` : '21px')};

  margin-right: ${({ noMargin, minHeight }) => (noMargin ? '0px' : minHeight ? `${minHeight - minHeight}px ` : '10px')};
  svg {
    position: absolute;
    right: 4px;
    top: 50%;
    transform: translateY(-50%);
    cursor: pointer;
    background: transparent;
    width: 12px;
    height: 10px;
  }
`

export const ItemsList = styled.div<{ width?: number }>`
  position: absolute;
  bottom: -3px;
  left: -4px;
  width: ${({ width }) => (width ? `${width + 8}px` : '103px')};
  padding: 4px;
  background: rgb(47, 47, 47);
  transform: translateY(100%);
  z-index: 1;
  border-radius: 3px;
    display: flex;
    flex-direction: column;
    overflow: scroll;
    height: 250px;
    &::-webkit-scrollbar {
        display: none;
    }
`

export const Item = styled.div<{ width?: number; minHeight?: number; isZeroItem?: boolean }>`
  background: rgb(47, 47, 47);
  box-shadow: inset 0.5px 0.5px 1px rgb(255 255 255 / 14%);
  font-size: 12px;
  border-radius: 2px;
  color: #fff;

  white-space: nowrap;
  cursor: pointer;
  overflow: hidden;
  min-height: ${({ minHeight }) => (minHeight ? `${minHeight}px` : '19px')};
  padding: ${({ width }) => (width ? '0px 0px 0px 5px' : '2px 0 2px 5px')};
  width: ${({ width }) => (width ? `${width}px` : '95px')};

  &:not(:nth-child(1)) {
    margin-top: 3px;
  }
  &:hover {
    background: rgb(60, 60, 60);
    overflow: ${({ isZeroItem }) => (isZeroItem === true ? 'hidden' : 'visible')};
    z-index: 2;
    min-width: ${({ width }) => (width ? `${width}px` : '95px')};
    width: ${({ isZeroItem, width }) => (isZeroItem === true ? width ? `${width}px` : '95px' : 'fit-content')};
  }
`

export const SearchInput = styled.input<{ width?: number }>`
  width: ${({ width }) => (width ? `${width - 12}px` : '95px')};
  background: rgba(255, 255, 255, 0.11);
  border: 0.3px solid rgba(255, 255, 255, 0.1);
  box-shadow: inset 1px 1px 1px rgb(0 0 0 / 20%);
  border-radius: 2px;
  padding: 1px 5px;
  color: #fff;
  font-weight: 500;
  font-size: 12px;
  margin-right: 10px;
`
